import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useEffect } from 'react';

const RefundTermsAndInsuranceStatic = () => {

    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

    return (
        <Box sx={{
            p: '1rem',
            backgroundColor: '#DCF1F0'
        }}>
            <Box sx={{
                maxWidth: '85rem',
                margin: 'auto'
            }}>
                <Box sx={(theme) => ({
                    display: 'flex',
                    padding: 0,
                    alignItems: 'center',
                    justifyContent: 'center',
                    [`${theme.breakpoints.down('sm')}`]: {
                        flexDirection: 'column-reverse'
                    }
                })}>
                    <Typography sx={{ flexBasis: '70%' }}>
                        <>
                            <Typography variant='h5' sx={(theme) => ({
                                color: 'text.secondary',
                                fontSize: '2rem',
                                fontWeight: 'bold'
                            })}>
                                Refund Terms and Insurance
                            </Typography>
                            <Typography>
                                
                            </Typography>
                        </>
                    </Typography>

                </Box>
            </Box>

        </Box>
    );
};

export default RefundTermsAndInsuranceStatic;